<div class="oxygen-permeability-container">
    <div class="oxygen-permeability-item-container">
        <div class="oxygen-permeability-item-input-container">
            <mat-form-field appearance="outline" class="oxygen-permeability-form-field">
                <mat-label>Oxygen permeability at 35&deg;C</mat-label>
                <input matInput #oxygenPermeabilityAt35CInput [(ngModel)]="oxygenPermeabilityAt35C"
                    class="oxygen-permeability oxygen-permeability-item-input"
                    (keyup.enter)="updateOxygenPermeabilityAt35C($event)" (keyup.escape)="cancelUpdateOxygenPermeabilityAt35C()"
                    (blur)="updateOxygenPermeabilityAt35C($event)" />
                <mat-icon matSuffix (mousedown)="clearOxygenPermeabilityAt35CInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div class="oxygen-permeability-item-container">
        <div class="oxygen-permeability-item-input-container">
            <mat-form-field appearance="outline" class="oxygen-permeability-form-field">
                <mat-label>If chemicals have been attached, entrapped or adsorbed to modify surface properties please indicate the oxygen permeability before and after the modification</mat-label>
                <input matInput #oxygenPermeabilityInput [(ngModel)]="oxygenPermeability"
                    class="oxygen-permeability oxygen-permeability-item-input"
                    (keyup.enter)="updateOxygenPermeability($event)" (keyup.escape)="cancelUpdateOxygenPermeability()"
                    (blur)="updateOxygenPermeability($event)" />
                <mat-icon matSuffix (mousedown)="clearOxygenPermeabilityInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div class="oxygen-permeability-item-container">
        <div class="oxygen-permeability-item-input-container">
            <mat-form-field appearance="outline" class="oxygen-permeability-form-field">
                <mat-label>Mean value &plusmn; standard deviation</mat-label>
                <input matInput #oxygenMeanValueStdDeviationInput [(ngModel)]="oxygenMeanValueStdDeviation"
                    class="oxygen-permeability oxygen-permeability-item-input"
                    (keyup.enter)="updateOxygenMeanValueStdDeviation($event)" (keyup.escape)="cancelUpdateOxygenMeanValueStdDeviation()"
                    (blur)="updateOxygenMeanValueStdDeviation($event)" />
                <mat-icon matSuffix (mousedown)="clearOxygenMeanValueStdDeviationInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
        <div class="input-error" *ngIf="hasFieldValidationError('oxygenMeanValueStdDeviation', 'required')">
            This is a required field.
        </div>
        <div class="input-error" *ngIf="!hasFieldValidationError('oxygenMeanValueStdDeviation', 'required') && hasFieldValidationError('oxygenMeanValueStdDeviation', 'pattern')">
            Invalid number entered.
        </div>
    </div>
    <div class="oxygen-permeability-item-container">
        <div class="oxygen-permeability-item-input-container">
            <mat-form-field appearance="outline" class="oxygen-permeability-form-field">
                <mat-label>Number of measurements</mat-label>
                <input matInput #oxygenNumberOfMeasurementsInput [(ngModel)]="oxygenNumberOfMeasurements"
                    class="oxygen-permeability oxygen-permeability-item-input"
                    (keyup.enter)="updateOxygenNumberOfMeasurements($event)" (keyup.escape)="cancelUpdateOxygenNumberOfMeasurements()"
                    (blur)="updateOxygenNumberOfMeasurements($event)" />
                <mat-icon matSuffix (mousedown)="clearOxygenNumberOfMeasurementsInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
        <div class="input-error" *ngIf="hasFieldValidationError('oxygenNumberOfMeasurements', 'required')">
            This is a required field.
        </div>
        <div class="input-error" *ngIf="!hasFieldValidationError('oxygenNumberOfMeasurements', 'required') && hasFieldValidationError('oxygenNumberOfMeasurements', 'pattern')">
            Invalid number entered.
        </div>
    </div>
    <div class="oxygen-permeability-item-container">
        <div class="oxygen-permeability-item-input-container">
            <mat-form-field appearance="outline" class="oxygen-permeability-form-field">
                <mat-label>Method used to determine oxygen permeability</mat-label>
                <input matInput #methodUsedToDetermineOxygenPermeabilityInput [(ngModel)]="methodUsedToDetermineOxygenPermeability"
                    class="oxygen-permeability oxygen-permeability-item-input"
                    (keyup.enter)="updateMethodUsedToDetermineOxygenPermeability($event)" (keyup.escape)="cancelUpdateMethodUsedToDetermineOxygenPermeability()"
                    (blur)="updateMethodUsedToDetermineOxygenPermeability($event)" />
                <mat-icon matSuffix (mousedown)="clearMethodUsedToDetermineOxygenPermeabilityInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
        <div class="input-error" *ngIf="hasFieldValidationError('methodUsedToDetermineOxygenPermeability', 'required')">
            This is a required field.
        </div>
    </div>
</div>